module.exports = __webpack_public_path__ + "static/media/MAPALL.037ee7ea.jpg";